// extracted by mini-css-extract-plugin
export default {"imageSlot":"imageDraggableComponent_imageSlot__Jh8Zd"};